import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { ClinicalExamModel } from '../models/ClinicalExamModel';

@Injectable()
export class ClinicalExamService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

    public getClinicalExamPatient(PatientCode: string) {
      let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<ClinicalExamModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ClinicalExam/GetClinicalExam_Patient', options);
    }
    public getClinicalExam(PatientCode: string,ExamDate:string,userid:string ) {
      let params = new HttpParams();
      params = params.append("ExamDate", ExamDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("userid", userid);
      const options = {
          params: params
      };
      return this.http.get<ClinicalExamModel>(this.urlsconfig.WebAPIURL_Test + 'api/ClinicalExam/GetClinicalExam', options);
    }
    public AddClinicalExam(ClinicalExam: ClinicalExamModel) {
            return this.http.post<ClinicalExamModel>(this.urlsconfig.WebAPIURL_Test + 'api/ClinicalExam/AddClinicalExam', ClinicalExam);
    }
    public deleteClinicalExam(ExamDate:string ,PatientCode: string,userid:string) {
      let params = new HttpParams();
      params = params.append("ExamDate", ExamDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("userid", userid);
      const options = {
          params: params
      };

      return this.http.get<ClinicalExamModel>(this.urlsconfig.WebAPIURL_Test + 'api/ClinicalExam/DelClinicalExam', options);
    }
}
